const Trix = require("trix");
Trix.config.blockAttributes.heading1.tagName = "h2";
module.exports = Trix
